import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Link, useSearchParams } from "react-router-dom"
import axios from "axios"
import AppLayout from "@/components/app/AppLayout"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { API_BASE } from "@/config/api"
import { HrSubnav } from "./HrSubnav"
import { toast } from "sonner"

const API = API_BASE
const ROLES = [
  { value: "receptionist", label: "Recepționer" },
  { value: "asistent_medical", label: "Asistent medical" },
  { value: "app", label: "Asistent personal (APP)" },
  { value: "psiholog", label: "Psiholog" },
  { value: "fizioterapeut", label: "Fizioterapeut" },
  { value: "kinetoterapeut", label: "Kinetoterapeut" },
  { value: "logoped", label: "Logoped" },
  { value: "contabil", label: "Contabil part-time" },
]

export default function HrEmployees() {
  const { t } = useTranslation()
  const [list, setList] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    cnp: "",
    address: "",
    role_code: "receptionist",
    hire_date: new Date().toISOString().slice(0, 10),
  })
  const [params] = useSearchParams()

  const load = () => {
    axios.get(`${API}/hr/employees`).then((r) => setList(r.data)).catch(() => {})
  }

  useEffect(() => {
    load()
    if (params.get("new") === "1") setShowForm(true)
  }, [params])

  const submit = async (e) => {
    e.preventDefault()
    try {
      const { data } = await axios.post(`${API}/hr/employees`, form)
      toast.success(t("app.hr.employees.toastAdded"))
      setShowForm(false)
      load()
      window.location.href = `/app/hr/employees/${data.id}`
    } catch (err) {
      toast.error(err.response?.data?.detail || "Eroare")
    }
  }

  return (
    <AppLayout title={t("app.hr.employees.title")}>
      <HrSubnav />
      <div className="flex justify-between mb-4">
        <p className="text-sm text-muted-foreground">Personal auxiliar (nu practicienii din echipă).</p>
        <Button size="sm" onClick={() => setShowForm(!showForm)}>{showForm ? "Anulează" : "Angajare nouă"}</Button>
      </div>
      {showForm && (
        <form onSubmit={submit} className="rounded-xl border border-border p-6 mb-6 space-y-4 max-w-xl">
          <div className="grid sm:grid-cols-2 gap-4">
            <div><Label>Prenume</Label><Input required value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} /></div>
            <div><Label>Nume</Label><Input required value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })} /></div>
            <div><Label>CNP</Label><Input required maxLength={13} value={form.cnp} onChange={(e) => setForm({ ...form, cnp: e.target.value })} /></div>
            <div><Label>Funcție</Label>
              <select className="w-full h-10 rounded-md border border-input bg-background px-3 text-sm" value={form.role_code} onChange={(e) => setForm({ ...form, role_code: e.target.value })}>
                {ROLES.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
              </select>
            </div>
            <div><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
            <div><Label>Telefon</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
            <div className="sm:col-span-2"><Label>Adresă</Label><Input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></div>
            <div><Label>Data angajării</Label><Input type="date" value={form.hire_date} onChange={(e) => setForm({ ...form, hire_date: e.target.value })} /></div>
          </div>
          <Button type="submit">Salvează angajat</Button>
        </form>
      )}
      <div className="rounded-xl border border-border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50"><tr><th className="text-left p-3">Nume</th><th className="text-left p-3">Funcție</th><th className="text-left p-3">CNP</th><th className="text-left p-3">Status</th><th /></tr></thead>
          <tbody>
            {list.map((e) => (
              <tr key={e.id} className="border-t border-border hover:bg-muted/30">
                <td className="p-3">{e.first_name} {e.last_name}</td>
                <td className="p-3">{e.role_code}</td>
                <td className="p-3 font-mono text-xs">{e.cnp_masked}</td>
                <td className="p-3">{e.status}</td>
                <td className="p-3 text-right"><Button variant="ghost" size="sm" asChild><Link to={`/app/hr/employees/${e.id}`}>Detalii</Link></Button></td>
              </tr>
            ))}
          </tbody>
        </table>
        {list.length === 0 && <p className="p-6 text-center text-muted-foreground">Niciun angajat încă.</p>}
      </div>
    </AppLayout>
  )
}
